export default __webpack_public_path__ + "static/media/tagline1.b3d051fa.png";